module.exports = __webpack_public_path__ + "img/tabicon_3.6c2db6c0.png";